const WebFont = require('webfontloader');

WebFont.load({
    google: {
        families: ['Montserrat:400,700']
    }
});